import { $ } from '@starberry/components';

const UserPendingActionsText = {
  $: 'Text',
  props: {
    fontSize: $('constants.body.bodySize.large'),
    mt: '0!important',
  },
  children: [
    {
      $: 'Text',
      props: {
        as: 'span',
        fontSize: 'inherit',
      },
      children: 'You have ',
    },
    {
      $: 'WrappedLink',
      props: {
        color: $('constants.colors.primary'),
        _hover: {
          textDecoration: 'underline',
        },
      },
      children: [
        {
          component: 'strong',
          provide: ['action'],
          children: (_, context) => {
            return `${
              context?.state?.action?.[0]?.pendingActionData
                ? context.state.action[0].pendingActionData.length
                : '??'
            } Pending Actions`;
          },
        },
      ],
    }
  ],
};

export default UserPendingActionsText;
